module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/2.1-register.7d6f2ce8.png";